export default __webpack_public_path__ + "static/media/aria-university-logo.09e10571.svg";